export default "__VITE_ASSET__4i5AdStO__"